import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-block" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.total === -1)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 0,
          name: "fa fa-spinner fa-spin"
        }))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.total), 1))
  ]))
}